import { MenuItem, TextField, TextFieldProps } from "@mui/material";
import { times } from "lodash";

type NumberOfFieldworkersInputProps = Omit<TextFieldProps, "select">;

export default function NumberOfFieldworkersInput(props: NumberOfFieldworkersInputProps) {
    return (
        <TextField {...props} select>
            {times(49).map(index => (
                <MenuItem key={index} value={index + 1}>
                    {index + 1}
                </MenuItem>
            ))}
        </TextField>
    );
}
